import { useForm } from 'react-final-form';
export const useFormInitialValues = () => {
  const {
    getState
  } = useForm();
  return getState().initialValues;
};